import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import TermSheetScheduleRowUpdateModalUI from './TermSheetScheduleRowUpdateModalUI.js'

class TermSheetScheduleRowUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      particular: '',
      particularError: null,
      termsAndConditions: '',
      termsAndConditionsError: null,
    }
  }

  render() {
    return (
      <TermSheetScheduleRowUpdateModalUI
        context={this.props.context}
        updateMode={this.props.updateMode}
        onCancelClick={this.onCancelClick}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        particular={this.state.particular}
        onParticularChange={(event) => this.setState({ particular: event.target.value })}
        particularError={this.state.particularError}
        setParticularError={(error) => this.setState({ particularError: error })}
        termsAndConditions={this.state.termsAndConditions}
        onTermsAndConditionsChange={(event) => this.setState({ termsAndConditions: event.target.value })}
        termsAndConditionsError={this.state.termsAndConditionsError}
        setTermsAndConditionsError={(error) => this.setState({ termsAndConditionsError: error })}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!this.props.row) return
    if (prevProps.row && prevProps.row.templateId === this.props.row.templateId
      && prevProps.updateMode === this.props.updateMode) return
    if (this.props.updateMode) {
      this.setState({
        particular: this.props.row.particular || '',
        termsAndConditions: this.props.row.termsAndConditions || '',
        particularError: null,
        termsAndConditionsError: null,
        successMsg: null,
        errorList: null,
      })
    }
  }

  onCancelClick = () => {
    this.props.onUpdateRowCancel()
  }

  onSubmit = () => {
    if (this.state.submitted || !this.props.row) return
    if (!this.state.particular) {
      this.setState({ particularError: 'Required' })
      return
    }
    if (!this.state.termsAndConditions) {
      this.setState({ termsAndConditionsError: 'Required' })
      return
    }
    this.setState({ successMsg: null, errorList: [], submitted: true })
    RestApiUtils.put(
      this.props.context,
      this.props.loan.loanId === 'master'
        ? `/api/su/master/termSheet/scheduleRows/${this.props.row.templateId}`
        : `/api/su/loans/${this.props.loan.loanId}/termSheet/scheduleRows/${this.props.row.templateId}`,
      this.onSubmitCallback,
      {
        particular: this.state.particular,
        termsAndConditions: this.state.termsAndConditions,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })
    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false,
    })
    if (!errorList || errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onUpdateRowCancel()
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default TermSheetScheduleRowUpdateModalSF
